/* Withdrawal form (design-reference/Withdrawal.dc.html): whole order or some items, validation, time of receipt,
   and the on-screen confirmation after Shopify's contact form has been sent. */
(function () {
  'use strict';
  function months(el) { return (el.getAttribute('data-months') || '').split(',').map(function (m) { return m.trim(); }); }
  function fmt(d, m, de) {
    var hm = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    return de ? d.getDate() + '. ' + m[d.getMonth()] + ' ' + d.getFullYear() + ', ' + hm + ' Uhr' : d.getDate() + ' ' + m[d.getMonth()] + ' ' + d.getFullYear() + ', ' + hm;
  }
  function init() {
    document.querySelectorAll('[data-psa-withdraw]').forEach(function (box) {
      var form = box.closest('form');
      form.noValidate = true;
      var de = box.getAttribute('data-lang') === 'de';
      var items = box.querySelector('[data-psa-items]');
      var q = function (n) { return box.querySelector('[name="' + n + '"]'); };
      var part = function () { var r = box.querySelector('input[name="scope"][value="part"]'); return !!(r && r.checked); };
      var sync = function () {
        items.hidden = !part();
        if (!part() && window.psaClearFieldError) window.psaClearFieldError(q('contact[Items]'));
      };
      box.addEventListener('change', function (e) { if (e.target.name === 'scope') sync(); });
      sync();
      form.addEventListener('submit', function (e) {
        var name = q('contact[name]'), email = q('contact[email]'), order = q('contact[Order number]'), it = q('contact[Items]');
        var ok = true, first = null;
        var bad = function (input, key) { window.psaShowFieldError(input, box.getAttribute(key)); ok = false; if (!first) first = input; };
        if (!name.value.trim()) bad(name, 'data-err-name');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) bad(email, 'data-err-email');
        if (!order.value.trim()) bad(order, 'data-err-order');
        if (part() && !it.value.trim()) bad(it, 'data-err-items');
        if (!ok) { e.preventDefault(); first.focus(); return; }
        var at = new Date();
        if (!part()) it.value = '';
        q('contact[Received]').value = fmt(at, months(box), de) + ' (' + at.toISOString() + ')';
        q('contact[Withdrawal from]').value = part() ? box.getAttribute('data-scope-part') + ': ' + it.value.trim() : box.getAttribute('data-scope-all');
        try {
          sessionStorage.setItem('psa-withdrawal', JSON.stringify({ name: name.value.trim(), email: email.value.trim(), order: order.value.trim(), part: part(), items: it.value.trim(), at: at.getTime() }));
        } catch (err) {}
      });
    });

    var sent = document.querySelectorAll('[data-psa-withdraw-sent]');
    if (!sent.length) return;
    var d = null;
    try { d = JSON.parse(sessionStorage.getItem('psa-withdrawal') || 'null'); } catch (e) {}
    sent.forEach(function (box) {
      if (!d) { box.querySelectorAll('[data-psa-needs-data]').forEach(function (el) { el.hidden = true; }); return; }
      var de = box.getAttribute('data-lang') === 'de';
      var put = function (k, v) { var el = box.querySelector('[data-psa-w="' + k + '"]'); if (el) el.textContent = v; };
      put('at', fmt(new Date(d.at), months(box), de));
      put('name', d.name);
      put('order', d.order);
      put('scope', d.part ? d.items : box.getAttribute('data-scope-all'));
      put('email', d.email);
      put('ok', (box.getAttribute('data-ok-text') || '').replace('{email}', d.email));
    });
    window.scrollTo(0, 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
